import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import type { CareActionItem } from '@/types/interfaces/careActions'

/** One row in the My Care inventory, matching the shared care-action card shape. */
export type MyCareItem = CareActionItem

/** Flat list of care rows; the client buckets (Upcoming/Past) and sorts. */
export type MyCareFeed = MyCareItem[]

export type MyCareQueryArg = { type?: 'labs' | 'imaging' | 'visits' } | void

export const myCareApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyCare: builder.query<MyCareFeed, MyCareQueryArg>({
            query: (arg) => ({
                url: apiEndpoints.myCare.list,
                params: arg && 'type' in arg && arg.type ? { type: arg.type } : undefined,
            }),
            providesTags: ['MyCare'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetMyCareQuery } = myCareApi
